// extracted by mini-css-extract-plugin
export default {"title":"AlertPopup_title__e7+Ac","subTitle":"AlertPopup_subTitle__41fC1","button":"AlertPopup_button__NM86t"};